import { AxiosResponse } from "axios";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { ServiceResponseData } from "../ServiceResponseData";

const ENDPOINT = "/device/onboarding";

export class DeviceOnBoardingCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: DeviceOnBoardingReqData;

    constructor(installationName: string) {
        super();
        this.payload = new DeviceOnBoardingReqData(installationName);
    }

    public async execute(): Promise<DeviceOnBoardingResData> {
        var res = await this.executeCommand(this.payload);
        return new DeviceOnBoardingResData(res);
    }
}

export class DeviceOnBoardingReqData {
    installationName: string;

    constructor(installationName: string) {
        this.installationName = installationName;
    }
}

export class DeviceOnBoardingResData extends ServiceResponseData {
    onBoardingResult: DeviceOnBoardingResultEnum;
    organizationName: string;
    organizationId: number;

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            var obj = response.data.Payload;
            if (obj.OnBoardingResult != null && Object.values(DeviceOnBoardingResultEnum).includes(obj.OnBoardingResult)) this.onBoardingResult = obj.OnBoardingResult;
            if (obj.OrganizationName != null) this.organizationName = obj.OrganizationName;
            if (obj.OrganizationId != null) this.organizationId = obj.OrganizationId;
        }
    }
}

export enum DeviceOnBoardingResultEnum {
    Success,
    AlreadyOnboarded,
    AlreadyOnboardedUnderAnotherOrganization,
    InstallationNotFound,
    LicensesNotAvailable,
}

export function DeviceOnBoardingResultEnumToLabel(value: DeviceOnBoardingResultEnum) {
    switch (value) {
        case DeviceOnBoardingResultEnum.Success:
            return "onBoarding.onBoardingResult.Success";
        case DeviceOnBoardingResultEnum.AlreadyOnboarded:
            return "onBoarding.onBoardingResult.AlreadyOnboarded";
        case DeviceOnBoardingResultEnum.AlreadyOnboardedUnderAnotherOrganization:
            return "onBoarding.onBoardingResult.AlreadyOnboardedUnderAnotherOrganization";
        case DeviceOnBoardingResultEnum.InstallationNotFound:
            return "onBoarding.onBoardingResult.InstallationNotFound";
        case DeviceOnBoardingResultEnum.LicensesNotAvailable:
            return "onBoarding.onBoardingResult.LicensesNotAvailable";
        default:
            return "common.unknown";
    }
}
